import events from "../models/events";
import { getOptionLabel } from '../../components/DynamicViewNew/helper';

export const types = {
  EVENTS_CLEAR: "EVENTS_CLEAR",
  EVENTS_REQUEST: "EVENTS_REQUESTED",
  EVENTS_DATA: "EVENTS_DATA",
  EVENTS_SUCCESS: "EVENTS_SUCCESS",
  EVENTS_FAILED: "EVENTS_FAILED",
  EVENTS_SUBMIT_REQUEST: "EVENTS_SUBMITTED",
  EVENTS_SUBMIT_SUCCESS: "EVENTS_SUBMIT_SUCCESS",
  EVENTS_SUBMIT_FAILED: "EVENTS_SUBMIT_FAILED",
  EVENTS_FORM_RESET: "EVENTS_FORM_RESET",
  EVENTS_SUBMIT_FORM: "EVENTS_SUBMIT_FORM",
  EVENT_PUBLISH: "EVENT_PUBLISH",
  EVENT_PUBLISH_SUCCESS: "EVENT_PUBLISH_SUCCESS",
  EVENT_PUBLISH_FAILED: "EVENT_PUBLISH_FAILED",
  EVENT_REMOVE: "EVENT_REMOVE",
  EVENT_REMOVE_SUCCESS: "EVENT_REMOVE_SUCCESS",
  EVENT_REMOVE_FAILED: "EVENT_REMOVE_FAILED",
};

export const actions = {
  eventsClear: () => {
    return { type: types.EVENTS_CLEAR };
  },
  eventSubmitForm: (payload, setLoading, callback) => {
    return { type: types.EVENTS_SUBMIT_FORM, value: payload, setLoading, callback };
  },
  eventsGet: (payload) => {
    return { type: types.EVENTS_REQUEST, value: payload };
  },
  eventsDataGet: (payload) => {
    return { type: types.EVENTS_DATA, value: payload };
  },
  eventsSubmit: (payload, callback = () => { }) => {
    return { type: types.EVENTS_SUBMIT_REQUEST, value: payload, callback };
  },
  eventsFormReset: (payload) => {
    return { type: types.EVENTS_FORM_RESET, value: payload };
  },
  eventsPublish: (values, callback = () => { }) => {
    return { type: types.EVENT_PUBLISH, value: values, callback };
  },
  eventsRemove: (payload, callback = () => { }) => {
    return { type: types.EVENT_REMOVE, value: payload, callback };
  },
};

function setViewConfig(value, defaultValue) {
  const { data, config } = value[Object.keys(value)[0]];
  if (!data) {
    return defaultValue;
  }
  const cfg = {
    title: {
      en: data.eventTitle || data.name,
      fr: data.eventTitle || data.name
    },
    tags: [
      {
        label: {
          en: 'Type',
          fr: 'Type',
        },
        value: getOptionLabel(config?.options?.typeOfEventOptions || [], data?.typeOfEvent, undefined, data),
        color: 'green',
      }
    ],
  };
  if (data.locationId) {
    const loc = data.linking.SCL[data.locationId] || null;
    if (loc) {
      cfg.tags.push({
        label: {
          en: 'Location',
          fr: 'Lieu',
        },
        value: loc.locationName,
        color: 'blue',
      });
    }
  }
  return cfg;
}

const reducer = (state = events, action) => {
  const { data = {} } = state;
  switch (action.type) {
    case types.EVENTS_CLEAR:
      return {
        ...state,
        loading: true,
        retrived: false,
        data: {
          events: [],
          eventsOptions: {},
          totalItems: 0,
        },
      };
    case types.EVENTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.EVENTS_DATA:
      return {
        ...state,
      };
    case types.EVENT_PUBLISH:
      return {
        ...state,
      };
    case types.EVENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        retrived: true,
        data: {
          ...data,
          ...action.value,
        },
        viewConfig: {
          ...setViewConfig(action.value, state.viewConfig),
        },
      }
    // case types.EVENTS_SUBMIT_REQUEST:
    // 	return {
    // 		...state,
    // 		loading: true,
    // 	};
    case types.EVENTS_SUBMIT_SUCCESS:
      if (!data[`${action.value.module}-${action.value.view}`]) {
        data[`${action.value.module}-${action.value.view}`] = {}
      }
      data[`${action.value.module}-${action.value.view}`].data = action.value.data;
      return {
        ...state,
        loading: false,
        retrived: true,
        data: {
          ...data,
        },
        viewConfig: {
          ...setViewConfig({ data: { data: action.value.data } }),
        },
      };
    case types.EVENTS_FORM_RESET:
      delete state.data[`${action.value.module}-${action.value.view}`];
      return {
        ...state,
        loading: false,
      };
    case types.EVENTS_SUBMIT_FAILED:
      return {
        ...state,
        loading: false,
        errors: action.value || null,
      };
    case types.EVENT_PUBLISH_SUCCESS:
      const { module: modu, view: vie, ...fData } = action.value;
      state.data[`${modu}-${vie}`].data = fData;
      return {
        ...state,
        loading: false,
      };
    case types.EVENT_PUBLISH_FAILED:
      return {
        ...state,
        loading: false,
        errors: action.value || null
      };
    default:
      return state;
  }
};

export default reducer;
